import { createContext, useContext, useMemo, useState } from "react";
import {useForumsListRequest, useForumsTopicRequest, useForumsTopicsListRequest} from "../request/api";

const ForumContext = createContext();

/**
 * Approach inspired by {@link https://blog.logrocket.com/guide-state-management-next-js/}
 */
export function ForumProvider({ children, forumId = 137 }) {
  const forumRequest = useForumsListRequest(
    {
      forumId,
    },
    {
      // shouldFetch: !!forumId,
      shouldFetch: true,
    }, {
      withCredentials: true,
    }
  );

  const value = useMemo(
    () => ({
      forums: forumRequest.data,
      isLoadingForums: forumRequest.isLoading,
      reloadForums: forumRequest.mutate,
      forumError: forumRequest.error,
    }),
    [forumRequest]
  );

  return (
    <ForumContext.Provider value={value}>{children}</ForumContext.Provider>
  );
}

export function useForumContext() {
  return useContext(ForumContext);
}
